import type { FaireProductEntity } from "../../entity_types/product";

export const p_eymaz3x7v8: FaireProductEntity = {
  token: "p_eymaz3x7v8",
  type: "product",
  name: "Team Logan Decal Sticker",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/43f7d18ca1d8b46283fc07d503e47167b4ea2b4cb983240e5e90cd2443362371.jpeg",
  galleryImageUrls: [],
  priceDollars: 3.44,
  description:
    "Declare your allegiance to Team Logan with our exclusive decal sticker inspired by Gilmore Girls! Crafted from high-quality vinyl, this sticker features a sleek design that celebrates the charismatic character, Logan Huntzberger. Perfect for laptops, notebooks, water bottles, or any smooth surface, it adds a stylish touch of fandom to your personal items. Show your support for Team Logan and embrace your love for Gilmore Girls with this essential decal sticker!",
  tags: [],
  msrpDollars: 6.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:00.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
